import { invoiceControlStatusConfig } from 'entities';

import { InvoiceNotAssigned } from './NotAssigned';
import { ReadyToInvoice } from './ReadyToInvoice';
import { WaitingInvoiceInfo } from './WaitingInvoiceInfo';
import { NoInvoiceAccess } from './NoAccess';
import { LegacyAdvise } from './LegacyAdvise';

import { useProjectProfile } from '../context';
import { useUser } from 'hooks/user';

import { validateHasInvoiceAccess } from './utils';

const statusComponents: Record<string, typeof WaitingInvoiceInfo> = {
  [invoiceControlStatusConfig.waitingInvoiceInfo.code]: WaitingInvoiceInfo,

  [invoiceControlStatusConfig.unassigned.code]: InvoiceNotAssigned,
};

export function Invoice() {
  const user = useUser();

  const { project } = useProjectProfile();

  if (project.legacy) return <LegacyAdvise />;

  if (!validateHasInvoiceAccess(project, user)) return <NoInvoiceAccess />;

  const StatusComponent = statusComponents[project.invoice.status];

  if (StatusComponent) return <StatusComponent />;

  return <ReadyToInvoice />;
}
